  <template>
  	<v-container fluid>		
      <grid-layout :layout.sync="layout"
      :margin="[1, 1]"
      :col-num="120"
      :row-height="20"
      :is-draggable="draggable"
      :is-resizable="resizable"
      :vertical-compact="vertical_compact"
      :prevent-collision="prevent_collision"
      :use-css-transforms="true"
      :responsive="responsive"

      >
      <!--  :max-rows="12" -->
      <grid-item v-for="item of layout"                  
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :minH="item.minH"
        :minW="item.minW"
        :key="item.i"
        drag-allow-from=".vue-draggable-handle"
        drag-ignore-from=".no-drag"
      >

     
    <!-- <v-card outlined width="200px" v-else-if="item.component=='status_queue'" style="width:100%; height:100%; object-fit: fill; overflow-y:hidden">
      <v-card-title v-text="$ml.get('status_queue')" class="caption justify-center pa-0 ma-0 error vue-draggable-handle"></v-card-title>
      
      <v-card-text  class="pa-1 pb-0 pt-1  no-drag text-center">
        <h1>{{ total_onqueue }}</h1>
        <p v-text="$ml.get('status_queue')" class="caption mb-0"></p>
      </v-card-text>
    </v-card>
    <v-card outlined width="200px" v-else-if="item.component=='status'" style="width:100%; height:100%; object-fit: fill; overflow-y:hidden">   
    <v-card-title  class="caption justify-start pa-0 ma-0 grey vue-draggable-handle">
      <v-icon small>mdi-axis-arrow-lock</v-icon>
    </v-card-title>                
      <v-card-text class="pa-3 no-drag">
        <p class="d-flex justify-center error">{{ $ml.get('offline') }}</p>
        <p class="d-flex justify-center mb-0 primary">{{ $ml.get('online') }}</p>
      </v-card-text>
    </v-card> -->
    <component 
      :is="item.component"       
      :ref_to_component="item.ref"
      :info_to_component="item.info_component"
      :layout="item.h"
    ></component>

  </grid-item>
</grid-layout>
</v-container>
</template>
<style scoped>
.vue-grid-item>>>.vue-resizable-handle{ /* /deep/ */
  background-color: white; /*#047dc3*/
  /* filter: grayscale(100%);*/ 
  /*filter: invert(100%);*/
  opacity:0.5;
  width:10px;
  height: 10px;
  /*filter: brightness(0.5);*/
  filter: hue-rotate(180deg); 
  /*filter: opacity(50%); */


}
</style>
<script>
  import events from '@/components/events/events.vue'
  // import daily_events from '@/components/lpr/daily_events.vue'
  import VueGridLayout from 'vue-grid-layout';
  import EventBus from '@/event-bus';
  // import dvr from '@/views/dvr.vue';
  import io from 'socket.io-client';
  import moment from 'moment';
  import axios from 'axios';
  import counter from '@/components/analytics/counter.vue'

  // import alerts from '@/components/lpr/alerts.vue'
  export default{
    name: 'dashboard_lpr',
    components: { 
      events , 
        // dvr, 
        moment, 
        // alerts, 
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        counter
      }, // daily_events
      data: () =>({
        layout: [],
        draggable: true,
        resizable: true,
        vertical_compact: false,
        prevent_collision: true,
        responsive: false,
        moment: moment,
        total_income: 0,
        news: 0,
        total_onqueue: 0,
        list: [],
        list_queue:[],
        hosts_onqueue: [],
             }), //data
      watch:{
        layout: function(v){
                // console.log('changeds', this.layout )
                var layout_t=this.layout_t, layout=this.layout;
                if (layout) {
                  var layout1 = JSON.stringify(layout)
                  localStorage.setItem('changed_profile_lpr',layout1);
                  // layout_t=v;
                }

              }, // layout
             }, //watch
             created(){
              /*this.get_list_queue();*/
              this.get_incomes();
              this.get_daily();
              let layout=[], len=0;
              let component_daily_events='daily_events';
              let component_events='events';
              let component_streams='dvr';
              let layout_daily={
                'x': 0,
                'y': 0,
                'w': 30,//3,
                'h': 5,//2,
                'i': len,
                'component': 'counter',
                info_component: { 
                  type : 'daily'
                }
              };
              layout.push(layout_daily);
              
              len++;
              let layout_monthly={
                x: 30,
                y: 0,
                w: 29,//3,
                h: 5,//2,
                i: len,
                component: 'counter',
                info_component: { 
                  type : 'monthly'
                }
              }
              layout.push(layout_monthly);
              len++;
              let layout_queue={
                x: 6,
                y: 0,
                w: 12,//2,
                h: 5,//2,
                i: len,
                component: 'status_queue',
              }
              // layout.push(layout_queue);
              len++;
              let layout_status={
                x: 9,
                y: 0,
                w: 12,//2,
                h: 5,//2,
                i: len,
                component: 'status',
              }
              // layout.push(layout_status);
              len++;
              let layout_events={
               'x': 59, //6,
               'y': 0, //3
               'w': 60,//6,
               'h': 39,//11,
               'i': len,
               minH: 11,
               minW: 6,
               'component': component_events,
               ref: 'lpr'
             }
             layout.push(layout_events);
             len++;
             let layout_alerts={
              'x': 0,
              'y': 5,//2,// 3
              'w': 59,//6,
              'h': 34,//9,
              'i': len,
              minH: 9,
              minW: 6,
              'component': component_events,
              ref: 'alerts'
            }
            layout.push(layout_alerts);
            this.layout=layout;
             }, //created
             watch:{
              /*list: function(){
                this.list_render;
              }*/
            }, //watch
            
            methods: {
              get_list_queue(){
                axios.defaults.withCredentials=true;
                  let api = this.$URL+'/api/events/stats'; // 3001
                  axios.get(api).then( res => {
                    this.total_onqueue=res.data.onQueue;
                    console.log(res, 'stats')
                  }).catch( error =>{
                    console.log(error)
                  })
                }, // get list
                get_incomes(){
                  axios.defaults.withCredentials=true;
                  let api = this.$URL+'/api/v1/eventbymonth/';
                  axios.post(api).then( res => {
                    this.total_income=res.data.count;
                    console.log(res, 'months')
                  }).catch( error =>{
                    console.log(error)
                  })
                }, // get incomes
                get_daily(){
                  axios.defaults.withCredentials=true;
                  let api = this.$URL + '/api/v1/eventbyday/';
                  axios.post(api).then( res => {
                    this.news=res.data.count;
                    console.log(res, 'news')
                  }).catch( error =>{
                    console.log(error)
                  })
                }, // get daily
                count_events(){
                  let list=this.list, totals=this.total_income, news=this.news, total_oq=this.total_onqueue, date, date_month;
                // for( var i in list){
                  date=this.moment(list.createdAt).format("YYYY-MM-DD HH:mm");
                  date_month=this.moment(list.createdAt).format("YYYY-MM");
                  if (date==this.moment().format("YYYY-MM-DD HH:mm")) {
                    news++;
                  }
                  if (date_month==this.moment().format("YYYY-MM")) {
                    totals++;
                  }
                // }
                this.news=news;
                this.total_income=totals;
              }
            }, // methods

            computed: {
              list_render: function(){

                return "ok";
        }//list_render
      }, //computed

      mounted(){


        EventBus.$on('profile_lpr', (actions) =>{
          // console.log(actions, 'profile')
          this.layout=actions;
          // this.check_selects(this.layout);
        });
        EventBus.$on('save_profile_lpr', () =>{ 
          const layout = JSON.stringify(this.layout)
          localStorage.setItem('save_profile_lpr',layout);
        })

        if (localStorage.getItem('changed_profile_lpr')) {    
          this.layout=JSON.parse(localStorage.getItem('changed_profile_lpr'));        
            // this.check_selects(this.layout);
          }

        // drawable options
        EventBus.$on('drawable_lpr', (actions) => { 
          this[actions.option]=actions.active;
          // console.log(this[actions.option],actions.option, actions.active, 'draw-opcion')

        });

        // Grids options
        EventBus.$on('grid_options_lpr', (ly) => {
          var layout =this.layout;
          
        });
        // http://localhost:3001/api/events/stats
        /*(const socketCounting=io(this.$protocol_socket + this.$localhost+':4550/LPR');
        
        var ev=this;
        socketCounting./on('event', function(message) {
          ev.list.push(message); 

        });
        const socketCounting1=io(this.$protocol_socket+this.$localhost+':4550/statistics');      
          var si=this;
          socketCounting1.on('service', function(message) {
            si.hosts_onqueue=message.onQueue;
            // console.log(message)
            
          });*/
          let ev=this;
          EventBus.$on('daily_events_lpr', (actions) => {
            ev.list=actions; 
            this.count_events();
          });


      }, //mounted
    };
  </script>